import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import _ from "lodash";

import { Input, Button } from "../../components/DesignSystem";

import logoVibraSvg from "../../assets/logo-vibra.svg";
import logoVibraPng from "../../assets/logo-vibra.png";

import "./index.scss";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hash } = useParams();
  // console.log(hash)

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [loginMessage, setLoginMessage] = useState("");

  const [showForgetPassword, setShowForgetPassword] = useState(false);

  const setGoToPage = useCallback(
    (userPermission) => {
      let goto = "";
      if (userPermission === 1 || userPermission === 2){
        // console.log(hash)
        let id = hash === undefined ? "" : "/" + hash
        goto = "/painel/meus-casos" + id;
      }
      else if (userPermission === 3) goto = "/caso/";

      localStorage.setItem("goto", goto);
      navigate(goto);
    },
    [navigate]
  );

  useEffect(() => {
    const cookiesScript1 = document.createElement("script");
    cookiesScript1.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
    cookiesScript1.type = "text/javascript";
    cookiesScript1.setAttribute("data-domain-script", "c1c7a222-e15d-46f1-aaad-5fc8f55b8197");
    document.head.appendChild(cookiesScript1);

    const cookiesScript2 = document.createElement("script");
    cookiesScript2.type = "text/javascript";
    cookiesScript2.innerHTML = "function OptanonWrapper() { }";
    document.head.appendChild(cookiesScript2);
  }, []);

  useEffect(() => {
    setLoginError("");
  }, [showForgetPassword]);

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (!_.isEmpty(user)) {
      setGoToPage(user.roles_id);
    }
  }, [navigate, setGoToPage]);

  function handleClickNewPassword(evt) {
    evt.preventDefault();
    setLoading(true);
    axios
      .post("/user/forget-password", { email: email })
      .then((response) => {
        setLoading(false);
        clearUserCredentials();
        setLoginMessage("Enviamos um email para você redefinir sua senha.");
        setLoginError("");
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        clearUserCredentials();
        setLoginMessage("");
        setLoginError("Redefinição incompleta. Tente novamente mais tarde.");
      });
  }

  function handleGoToFirstAccess() {
    navigate("/primeiro-acesso");
  }

  function clearUserCredentials() {
    setEmail("");
    setPassword("");
  }

  function getGreeting() {
    const hour = new Date().getHours();

    if (hour > 5 && hour < 12) return "Bom dia";
    else if (hour >= 12 && hour < 18) return "Boa tarde";
    else return "Boa noite";
  }

  function fetchLogin(evt) {
    evt.preventDefault();
    setLoading(true);
    axios
      .post("/signin", { login: email, password })
      .then(({ data }) => {
        dispatch({ type: "CHANGE_USER", payload: data });
        axios.defaults.headers.common["token"] = data.token;
        localStorage.setItem("user", JSON.stringify(data));
        setGoToPage(data.roles_id);
      })
      .catch((error) => {
        console.log(error);
        if (error.response.status === 503) {
          setLoginMessage("");
          setLoginError("A plataforma se encontra em manutenção. Tente novamente mais tarde.");
        } else if (!error.response || error.response.status !== 401) {
          setLoginMessage("");
          setLoginError("Login incompleto. Tente novamente mais tarde.");
        } else {
          setLoginMessage("");
          setLoginError(
            'Usuário e/ou senha inválidos.<br/> Tente novamente ou clique em "Esqueceu a senha?" para redefini-la.'
          );
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function changeToForgetPassword(boll) {
    setLoginMessage("");
    setLoginMessage("");
    setShowForgetPassword(boll);
  }

  return (
    <div className="login">
      <section>
        <header>
          <div className="login__logo">
            <picture>
              <source type="image/svg+xml" srcSet={logoVibraSvg} />
              <img src={logoVibraPng} alt="Vibra" />
            </picture>
          </div>
        </header>
        {!showForgetPassword && (
          <form className="login__form" onSubmit={fetchLogin}>
            <div className="login__form__header">
              <h3>Fazer Login</h3>
              <p>{getGreeting()}. Bem vindo a nova Plataforma de Negociações da Vibra. Ficamos felizes em tê-lo conosco.</p>
            </div>
            <div className="login__form__main">
              <Input
                label="Email"
                placeholder=""
                type="email"
                value={email}
                onChange={setEmail}
              />
              <Input
                label="Senha"
                placeholder=""
                type="password"
                value={password}
                onChange={setPassword}
              />
              <div
                className={
                  loginMessage
                    ? "login__form__message login__form__message--visible"
                    : "login__form__message"
                }
                dangerouslySetInnerHTML={{ __html: loginMessage }}
              />
              <div
                className={
                  loginError
                    ? "login__form__error login__form__error--visible"
                    : "login__form__error"
                }
                dangerouslySetInnerHTML={{ __html: loginError }}
              />
              <Button
                type="submit"
                contained
                disabled={loading}
                loading={loading}
                style={{ width: "100%" }}
              >
                Continuar
              </Button>
            </div>
            <div className="login__form__footer">
              <div
                className="login__form__forget__password"
                onClick={() => changeToForgetPassword(true)}
              >
                Esqueceu sua senha?
              </div>
              <div className="login__form__first-access">
                <p>Nunca acessou o Pagdeal?</p>
                <button type="button" onClick={handleGoToFirstAccess}>
                  Primeiro acesso
                </button>
              </div>
            </div>
          </form>
        )}
        {showForgetPassword && (
          <form className="login__form" onSubmit={handleClickNewPassword}>
            <div className="login__form__header">
              <h3>Esqueci minha senha</h3>
              <p>Informe seu Email e aguarde nosso contato</p>
            </div>
            <div className="login__form__main">
              <Input
                label="Email"
                placeholder=""
                type="email"
                value={email}
                onChange={setEmail}
              />
              <div
                className={
                  loginMessage
                    ? "login__form__message login__form__message--visible"
                    : "login__form__message"
                }
                dangerouslySetInnerHTML={{ __html: loginMessage }}
              />
              <div
                className={
                  loginError
                    ? "login__form__message login__form__message--visible"
                    : "login__form__message"
                }
                dangerouslySetInnerHTML={{ __html: loginError }}
              />
              <Button
                contained
                loading={loading}
                //onClick={handleClickNewPassword}
                style={{ width: "100%" }}
              >
                Redefinir Senha
              </Button>
            </div>
            <div className="login__form__footer">
              <div
                className="login__form__forget__password"
                onClick={() => changeToForgetPassword(false)}
              >
                Voltar para o login
              </div>
            </div>
          </form>
        )}
        <footer>
          <a href="https://www.vibraenergia.com.br/portal-da-privacidade" target="_blank">
            Acesse o Portal de Privacidade da Vibra!
          </a>
        </footer>
      </section>
      <div className="login__image">
        {/* NASDAQ 2025
        <span role="img" aria-label="rocket">🚀</span> */}
      </div>
    </div>
  );
}

export default Login;
